/* ── CSS Fixes ── */
(function() {
  var s = document.createElement('style');
  s.textContent = '.ai-answer { background: #ffffff !important; } .ai-answer-body { color: #1c2b4a !important; background: #ffffff !important; } .ai-answer-body p { color: #1c2b4a !important; } .ai-answer-footer { background: #ffffff !important; } .field { display: block !important; width: 100% !important; margin-bottom: 16px !important; } .field label { display: block !important; float: none !important; width: 100% !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase !important; letter-spacing: 0.8px !important; color: #8899bb !important; margin-bottom: 7px !important; padding: 0 !important; text-align: left !important; } .field input, .field select, .field textarea { display: block !important; width: 100% !important; float: none !important; margin-left: 0 !important; } .field-row { display: grid !important; grid-template-columns: 1fr 1fr !important; gap: 14px !important; } .form-body { padding: 28px !important; }';
  document.head.appendChild(s);
})();

/* ── FAQ Toggle ── */
function toggleFaq(btn) {
  var item = btn.closest('.faq-item');
  var isOpen = item.classList.contains('open');
  item.classList.toggle('open', !isOpen);
}
function openFaq(id) {
  var el = document.getElementById(id);
  if (el) { el.classList.add('open'); el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
}
function openFaqCard(id) {
  var card = document.getElementById(id);
  if (card) { card.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
}

/* ── Scroll to form ── */
function scrollToForm() {
  var wrap = document.getElementById('form-wrap');
  wrap.classList.add('visible');
  setTimeout(function() { wrap.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
}

/* ── KI-Suche ── */
/* Wissensbasis liegt sicher im Backend (propoxan_api.py) */

function closeAI() {
  document.getElementById('ai-answer').classList.remove('visible');
  document.getElementById('search-input').value = '';
}

async function askAI() {
  var input = document.getElementById('search-input');
  var question = input.value.trim();
  if (!question || question.length < 3) return;

  var panel = document.getElementById('ai-answer');
  var body = document.getElementById('ai-answer-body');
  var btn = document.getElementById('search-btn');

  panel.classList.add('visible');
  body.innerHTML = '<div class="ai-typing"><span></span><span></span><span></span></div>';
  btn.classList.add('loading');
  btn.disabled = true;

  try {
    var response = await fetch('https://api.propoxan.com/ask', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ question: question })
    });

    var data = await response.json();
    var text = data.answer || 'Entschuldigung, ich konnte Ihre Frage gerade nicht beantworten. Bitte kontaktieren Sie uns direkt.';

    body.innerHTML = '<p>' + text.replace(/\n\n/g, '</p><p>').replace(/\n/g, ' ') + '</p>';
  } catch(e) {
    body.innerHTML = '<p>Entschuldigung, der Assistent ist gerade nicht erreichbar. Bitte schreiben Sie uns direkt an <strong>service@orvantis-pharma.com</strong>.</p>';
  }

  btn.classList.remove('loading');
  btn.disabled = false;
}

document.addEventListener('click', function(e) {
  if (!e.target.closest('.search-wrap')) {
    var panel = document.getElementById('ai-answer');
    if (panel && !document.getElementById('search-input').value.trim()) {
      panel.classList.remove('visible');
    }
  }
});

/* ── Form Submit ── */
function submitForm() {
  var fn = document.getElementById('f-firstname').value.trim();
  var email = document.getElementById('f-email').value.trim();
  var subject = document.getElementById('f-subject').value;
  var msg = document.getElementById('f-message').value.trim();
  if (!fn) { alert('Bitte geben Sie Ihren Vornamen ein.'); return; }
  if (!email || !email.includes('@')) { alert('Bitte geben Sie eine gültige E-Mail-Adresse ein.'); return; }
  if (!subject) { alert('Bitte wählen Sie einen Betreff aus.'); return; }
  if (!msg) { alert('Bitte geben Sie Ihre Nachricht ein.'); return; }
  var btn = document.getElementById('submit-btn');
  btn.disabled = true; btn.textContent = 'Wird gesendet…';
  var fd = new FormData();
  fd.append('form_type', 'contact'); fd.append('utf8', '✓');
  fd.append('contact[name]', fn + ' ' + document.getElementById('f-lastname').value.trim());
  fd.append('contact[email]', email);
  fd.append('contact[phone]', document.getElementById('f-order').value.trim());
  fd.append('contact[body]', '[' + subject + ']\n\n' + msg);
  fetch('/contact', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
  .then(function() {
    var s = document.getElementById('success-msg');
    s.style.display = 'flex'; btn.style.display = 'none';
    ['f-firstname','f-lastname','f-email','f-order','f-message'].forEach(function(id){ document.getElementById(id).value=''; });
    document.getElementById('f-subject').value = '';
  })
  .catch(function() {
    btn.disabled = false; btn.textContent = 'Nachricht absenden';
    alert('Fehler. Bitte schreiben Sie uns direkt an service@orvantis-pharma.com');
  });
}